import React, {useState, useEffect, useContext} from 'react'

import Loader from '../components/Loader'
import {
    getProgramOutreachConfiguration,
    getSignOut,
    getValidateSession,
} from '../services/outReach'
import Favicon from 'react-favicon'
import {faviconURLAtom} from '../myAccount/containers/Layout'
import {useRecoilState} from 'recoil'

export const SettingContext = React.createContext()

export const SettingsProvider = ({children}) => {
    const [loading, setLoading] = useState(true)
    const [logged, setLogged] = useState(false)
    const [showManageAccont, setShowManageAccont] = useState(false)
    const [appConfig, setAppConfig] = useState({})
    const [faviconUrl, setFaviconUrl] = useRecoilState(faviconURLAtom)

    useEffect(() => {
        setLoading(true)
        const promise1 = new Promise(async resolve => {
            const result = await getProgramOutreachConfiguration()
            if (Object.keys(result).length > 0) {
                setAppConfig({
                    ...appConfig,
                    ...result.configuration,
                })
            }
            resolve()
        })
        const promise2 = new Promise(async resolve => {
            if (
                window.location.pathname !== '/' &&
                window.location.pathname !== '/signup' &&
                window.location.pathname !== '/registration' &&
                window.location.pathname !== '/signup/registration' &&
                window.location.pathname !== '/outreach' &&
                window.location.pathname !== '/signup/outreach' &&
                window.location.pathname !== '/signup/' &&
                window.location.pathname.includes('/signup/outreach') === false
            ) {
                const result = await getValidateSession()

                if (Object.keys(result).length > 0) {
                    if (result.milestone === false)
                        sessionStorage.setItem('milestone', String(false))
                    if (result['open-on-section'])
                        sessionStorage.setItem(
                            'openOnSection',
                            String(result['open-on-section'])
                        )
                    login()
                } else {
                    sessionStorage.clear()
                }
            }
            resolve()
        })
        Promise.all([promise1, promise2])
            .then(function(values) {
                setLoading(false)
                // console.log('Settings.js .then Promise->', values)
            })
            .catch(function(error) {
                // console.log('Settings.js .catch Promise->', error)
            })
    }, [])

    const setEnvironment = previousSession => {}
    const login = token => {
        // const cookies = new Cookies()
        //  cookies.set('jwt-token', token, {path: '/'})
        setLogged(true)
    }

    const logout = () => {
        window.sessionStorage.clear()
        // setLogged(false)
        // window.localStorage.removeItem('clientObject')
        // window.localStorage.removeItem('routeObject')
        // getSignOut()

        new Promise(async resolve => {
            const result = await getSignOut()
            if (result.success.logouturl) window.location.assign(result.success.logouturl)
            else setLogged(false)
            resolve()
        })
        // const cookies = new Cookies()
        // cookies.remove('jwt-token')
    }

    const toggleManageAccount = () => {
        setShowManageAccont(!showManageAccont)
    }

    if (loading) {
        return (
            <div
                style={{
                    marginLeft: '48%',
                    marginTop: '25%',
                }}
            >
                <Loader />
            </div>
        )
    }

    return (
        <div className={'reg-page__wrapper unit-' + appConfig.unit || ''}>
            <Favicon url={faviconUrl ? faviconUrl : appConfig.faviconUrl} />
            <SettingContext.Provider
                value={{
                    appConfig,
                    logged,
                    setLogged,
                    login,
                    logout,
                    toggleManageAccount,
                    showManageAccont,
                }}
            >
                {children}
            </SettingContext.Provider>
        </div>
    )
}

export const useSettings = () => {
    return useContext(SettingContext)
}
